import { render, staticRenderFns } from "./advance-notice.vue?vue&type=template&id=0dceb04f&scoped=true&"
import script from "./advance-notice.vue?vue&type=script&lang=js&"
export * from "./advance-notice.vue?vue&type=script&lang=js&"
import style0 from "./advance-notice.vue?vue&type=style&index=0&id=0dceb04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dceb04f",
  null
  
)

export default component.exports